import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * PeakTimeWidget - Widget para mostrar mejores momentos de venta
 * @param {Object} bestDay - { day_name, total_sales }
 * @param {Object} bestHour - { hour_num, total_sales }
 */
const PeakTimeWidget = ({ bestDay, bestHour }) => {
    const { t } = useTranslation();

    const formatHour = (hour) => {
        if (hour === undefined || hour === null) return '-';
        const h = parseInt(hour);
        const ampm = h >= 12 ? 'PM' : 'AM';
        const formattedHour = h % 12 || 12;
        return `${formattedHour} ${ampm}`;
    };

    const translateDay = (dayName) => {
        if (!dayName) return '-';
        // Map English day names to translation keys if needed, 
        // or rely on backend returning localized names if configured.
        // Assuming backend returns English names like 'Monday', 'Tuesday'...
        return t(`days.${dayName.toLowerCase().trim()}`, dayName);
    };

    return (
        <Card className="h-100">
            <Card.Body>
                <Card.Title className="mb-4">{t('dashboard.peakTimes')}</Card.Title>
                <Row className="text-center">
                    <Col xs={6} className="border-end">
                        <div className="display-4 mb-2">📅</div>
                        <h6 className="text-muted text-uppercase small">{t('dashboard.bestDay')}</h6>
                        <h4>{bestDay ? translateDay(bestDay.day_name) : '-'}</h4>
                    </Col>
                    <Col xs={6}>
                        <div className="display-4 mb-2">⏰</div>
                        <h6 className="text-muted text-uppercase small">{t('dashboard.bestHour')}</h6>
                        <h4>{bestHour ? formatHour(bestHour.hour_num) : '-'}</h4>
                    </Col>
                </Row>
                <div className="mt-3 text-center">
                    <small className="text-muted">
                        {t('dashboard.peakTimesDescription')}
                    </small>
                </div>
            </Card.Body>
        </Card>
    );
};

export default PeakTimeWidget;
